// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn_2sx","primary":"primary_1RF","wide":"wide_384","icon-arrow":"icon-arrow_2Pj"};